// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"278":"a88ce647","329":"775702c9","571":"44445e01"}[chunkId] + ".chunk.js";
};